import { PlacementOnCanvas } from './placement-on-canvas';
import { ICanvasBaseObject } from './i-canvas-base-object';

export abstract class CanvasBaseObject implements ICanvasBaseObject {
  constructor(
    public id: number,
    public x: number,
    public y: number,
    public width: number,
    public height: number,

  ) {}
  public toWebGl() {
    return new PlacementOnCanvas(
      (this.x / 100) * 2 - 1,
      (this.y / 100) * 2 - 1,
      (this.width / 100) * 2,
      (this.height / 100) * 2,
    );
  }
  public to2DCanvas(stepX: number, stepY: number) {
    return new PlacementOnCanvas(
      this.x * stepX,
      this.y * stepY,
      this.width * stepX,
      this.height * stepY,
    );
  }

  public equalTo(other: CanvasBaseObject) {
    return (
      this.x === other.x &&
      this.y === other.y &&
      this.width === other.width &&
      this.height === other.height
    );
  }
  public ingest(placement: CanvasBaseObject | PlacementOnCanvas) {
    this.x = placement.x;
    this.y = placement.y;
    this.width = placement.width;
    this.height = placement.height;
  }
  public exportPlacement(): PlacementOnCanvas {
    return new PlacementOnCanvas(
      this.x,
      this.y,
      this.width,
      this.height,
    );
  }
}
